const INITIAL_STATE = {
  customersList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_CUSTOMERS': {
      return { ...state, customersList: action.customers };
    }
    default:
      return state;
  }
};
